import {
  validateDraftEstimatePaymentSchedule,
  type DraftEstimatePaymentSchedule,
} from '@/components/organisms/payment-schedules/estimateTemplateValidation';

interface ProposalScheduleOption {
  label: string;
  paymentScheduleTemplate?: DraftEstimatePaymentSchedule | null;
  total: number;
  /** Absent legacy deposit facts must be resolved by the server. */
  depositRequired?: boolean;
  depositAmount?: number;
}

/** The caller supplies the same priced totals and deposit shown on each option. */
export function assessProposalPaymentSchedules(
  options: ProposalScheduleOption[],
  requireScheduleAboveAmount = 0,
  allowPaymentSchedules?: boolean,
): { invalidReason: string | null; missingRequiredReason: string | null } {
  let invalidReason: string | null = null;
  let missingRequiredReason: string | null = null;
  for (const option of options) {
    const label = option.label || 'This option';
    if (option.paymentScheduleTemplate) {
      if (allowPaymentSchedules === false) {
        invalidReason ??= `Payment schedules are disabled. Remove the schedule in "${label}" before saving or sending.`;
        continue;
      }
      if (option.depositRequired === undefined || option.depositAmount === undefined) continue;
      const errors = validateDraftEstimatePaymentSchedule(
        option.paymentScheduleTemplate,
        option.total,
        { required: option.depositRequired, amount: option.depositAmount },
      );
      if (!invalidReason && errors.length > 0) {
        invalidReason = `Payment schedule in "${label}": ${errors[0]}`;
      }
    } else if (
      !missingRequiredReason &&
      requireScheduleAboveAmount > 0 &&
      option.total > requireScheduleAboveAmount
    ) {
      missingRequiredReason = `Set up a payment schedule in "${label}" before sending.`;
    }
  }
  return { invalidReason, missingRequiredReason };
}
